import { config } from '../config';

const errorMessage = '[apiUser] error to method';

export const apiUser = {
  fetchMe: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.get(config.API.USERS.ME);
      return response.data;
    } catch (error) {
      console.error(errorMessage + 'fetchMe', error);
      throw error;
    }
  },
  fetchActivity: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.put(config.API.USERS.ACTIVITY);
      return response.data;
    } catch (error) {
      console.error(errorMessage + 'fetchActivity', error);
      throw error;
    }
  },
  fetchUserById: async (axiosPrivate, userId) => {
    try {
      const response = await axiosPrivate.get(`${config.API.USERS.BASE}/${userId}`);
      return response.data;
    } catch (error) {
      console.error(errorMessage + 'fetchUserById', error);
      throw error;
    }
  },
  fetchCheckBlock: async (axiosPrivate, userId) => {
    try {
      const response = await axiosPrivate.get(config.API.USERS.CHECK_BLOCK(userId));
      return response.data;
    } catch (error) {
      console.error(errorMessage + 'fetchCheckBlock', error);
      throw error;
    }
  },
  fetchBlockUserById: async (axiosPrivate, userId) => {
    try {
      const response = await axiosPrivate.post(config.API.USERS.BLOCK_BY_ID(userId));
      return response.data;
    } catch (error) {
      console.error(errorMessage + 'fetchBlockUserById', error);
      throw error;
    }
  },
  fetchUnblockUserById: async (axiosPrivate, userId) => {
    try {
      const response = await axiosPrivate.post(config.API.USERS.UNBLOCK_BY_ID(userId));
      return response.data;
    } catch (error) {
      console.error(errorMessage + 'fetchUnblockUserById', error);
      throw error;
    }
  },
  getReferralLink: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.get(config.API.USERS.REFERRAL_LINK);
      return response.data;
    } catch (error) {
      console.error(errorMessage + 'getReferralLink', error);
      throw error;
    }
  }
};
